import _ from 'lodash';
import moment from 'moment';

const AppraiserUnavailableDataMapper = {
  toExcludedDateIntervals: appraiserUnavailableData => {
    const excludedDateIntervals = appraiserUnavailableData.map(period => ({
      start: moment(period.Start).startOf('week').toDate(),
      end: moment(period.End).endOf('week').toDate()
    }));
    return _.sortBy(excludedDateIntervals, r => r.start);
  }
};

export default AppraiserUnavailableDataMapper;
